import { SkeletonLoaderArea, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const Root = styled.div<{
  $isHighlighted?: boolean;
  $isDefaultVariant: boolean;
}>`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  ${({ $isDefaultVariant }) =>
    $isDefaultVariant &&
    css`
      border-radius: 8px;
      background: var(--background-soft);
    `};
  cursor: pointer;
  box-sizing: border-box;
  ${({ $isDefaultVariant }) =>
    $isDefaultVariant
      ? css`
          padding: 12px;
        `
      : css`
          padding: 12px 20px;
        `}
  &:hover {
    background-color: var(--surface-hover);
  }
`;

export const FlexWrapper = styled.div`
  display: flex;
  gap: 12px;
  min-width: 0;
`;

export const Content = styled.div`
  width: 100%;
  min-width: 0;
  flex: 1;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
  min-width: 0;
  gap: 32px;
`;

export const CardTitle = styled.div<{
  $isDefaultVariant: boolean;
}>`
  ${({ $isDefaultVariant }) =>
    $isDefaultVariant ? typographyV2.titleMd : typographyV2.titleBase};
  overflow: hidden;
  color: var(--text-default);
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DateLabel = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const CardDescription = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
`;

export const Description = styled.div`
  display: flex;
  gap: 8px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
`;

export const GreyDot = styled.span`
  width: 2px;
  height: 2px;
  border-radius: 50%;
  display: inline-block;
  background-color: var(--icon-soft);
`;

export const CardType = styled.div<{ $isMarketWide?: boolean }>`
  ${typographyV2.titleSm};
  color: var(--text-soft);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 0 1 auto;
`;

export const TickerLabel = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
  flex-shrink: 0;
`;

export const styledLoaderAreas: SkeletonLoaderArea[] = [
  {
    styles: {
      width: '100%',
      height: '100px',
      borderRadius: '8px',
    },
  },
];

export const MarketFooterContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  ${GreyDot}:last-child {
    display: none;
  }
`;

export const MarketWideIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
`;
